import {
  Component, Inject,
} from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialogRef,
} from '@angular/material/dialog';
import { UploadCourseDocumentsComponent } from 'src/app/components/upload-course-documents/upload-course-documents.component';

@Component({
  selector: 'app-upload-course-documents-dialog',
  templateUrl: './upload-course-documents-dialog.component.html',
  styleUrls: [ './upload-course-documents-dialog.component.scss' ],
})
export class UploadCourseDocumentsDialogComponent {
  courseItemId: number;

  constructor(
    public dialogRef: MatDialogRef<UploadCourseDocumentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { courseItemId: number },
  ) {
    this.courseItemId = data.courseItemId;
  }

  onCloseModal(): void {
    this.dialogRef.close();
  }

  onDocumentsUploaded(): void {
    this.dialogRef.close('uploaded');
  }
}

